import { useState } from "react";
import TextInputField from "../../_utils/CommonInputFields/TextInputField";
import { linkIdentifier } from "../../../utils/linkIdentifier";
import TickerAnimation from "../TickerAnimation";

const NameFieldCard = ({
  value = "",
  previewMode = false,
  onChange = () => {},
  title = "",
  subHeader = "",
  placeholder = "",
  note = "",
  fieldName = "",
  minLength = 0,
  mode = "strict",
  hasError = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (hasError) {
      return "error";
    }

    if (length === 0) {
      return "default";
    }

    if (mode === "alwaysValid") {
      return "verified";
    }

    if (mode === "soft") {
      return focused && "typing";
    }

    if (length >= minLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  if (previewMode) {
    return (
      <div className="global-card-create">
        <p className="text-text-primary font-semibold text-font-md mb-margin-md capitalize">
          {title}
        </p>

        <div className="text-font-sm text-text-primary flex flex-col gap-gap-xs flex-1">
          <TickerAnimation
            text={value ? linkIdentifier(String(value)) : "Not available"}
          />

          {subHeader && (
            <p className="text-font-xs text-text-secondary">{subHeader}</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="global-card-create w-width-full">
      <p className="font-semibold text-font-md text-text-primary mb-margin-md capitalize">
        {title}
      </p>

      {subHeader && (
        <p className="text-font-xs text-text-secondary mb-margin-md">
          {subHeader}
        </p>
      )}

      <div className="flex flex-col gap-y-gap-sm">
        <TextInputField
          placeholder={placeholder}
          name={fieldName}
          fontKind="big"
          bgColor="var(--primary-card)"
          fgColor="var(--text-primary)"
          value={value}
          isFullWidth={true}
          adornment=""
          variant={computeVariant(value, isFocused)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onInput={(e) => {
            const cleaned = e.target.value.replace(/\s+/g, " ").trimStart();
            onChange(cleaned);
          }}
        />
        {note && (
          <p className="font-normal text-font-xs text-text-secondary">{note}</p>
        )}
      </div>
    </div>
  );
};

export default NameFieldCard;
